<template>
  <div class="md:flex md:space-x-5" v-if="!isLoading">
    <div class="md:w-1/2">
      <table
        class="market-data-table table-fixed w-full divide-y divide-gray-200"
      >
        <thead>
          <tr class="text-xs text-center">
            <th class="w-1/2 font-extralight text-left">Markets</th>
            <th class="w-auto font-extralight">Sell</th>
            <th class="w-auto font-extralight">Buy</th>
            <th class="w-auto font-extralight">Spread</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr
            class="hover:bg-white"
            v-for="(data, index) in forexData.slice(0, 5)"
            :key="index"
          >
            <td class="uppercase text-gray-900 font-semibold">
              <img class="float-left mr-1" :src="`/images/currency/${data.icon}.png`" width="24" alt="Forex currency">{{ data.symbol }}
            </td>
            <td class="text-center text-red-500">{{ data.sell }}</td>
            <td class="text-center text-green-450">{{ data.buy }}</td>
            <td class="text-center">{{ data.spread }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="md:w-1/2">
      <table
        class="market-data-table table-fixed w-full divide-y divide-gray-200"
      >
        <thead class="hidden md:table-header-group">
          <tr class="text-xs text-center">
            <th class="w-1/2 font-extralight text-left">Markets</th>
            <th class="w-auto font-extralight">Sell</th>
            <th class="w-auto font-extralight">Buy</th>
            <th class="w-auto font-extralight">Spread</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200">
          <tr
            class="hover:bg-white"
            v-for="(data, index) in forexData.slice(6, 13)"
            :key="index"
          >
            <td class="uppercase text-gray-900 font-semibold">
              <img class="float-left mr-1" :src="`/images/currency/${data.icon}.png`" width="24" alt="Forex Currency">{{ data.symbol }}
            </td>
            <td class="text-center text-red-500">{{ data.sell }}</td>
            <td class="text-center text-green-450">{{ data.buy }}</td>
            <td class="text-center">{{ data.spread }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="md:flex md:space-x-5" v-else>
    <vcl-table />
  </div>
</template>
<script>
import { VclTable } from "vue-content-loading";

const axios = require("axios");
export default {
  components: { VclTable },
  data() {
    return {
      isLoading: true,
      forexData: [],
    };
  },
  created() {
    this.isLoading = true;
    let self = this;
    axios
      .get("/api/public/forexData")
      .then((response) => {
        console.log(response);
        self.forexData = response.data.rates;
        this.isLoading = false;
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
</script>
<style scoped>
</style>